import config from "config/config";

export async function validatePolicyNumber(queryString) {
  let options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
  };
  const response = await fetch(
    config.REG_API_BASE_URL + "/User/policy/validate?" + queryString,
    options
  );
  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    if (data) {
      return data;
    }
    return;
  }
}
